import { api } from './api';

export interface QaResult {
  reply: string;
  /** USD cost — customers see this; model name is operator-side only. */
  costUsd: number;
  citedFactIds: number[];
}

export interface FactRow {
  factId: string;
  accountCode: string;
  scenario: string;
  amount: number;
  periodStart: string;
  periodEnd: string;
  sourceRowRef: string | null;
  dim: Record<string, unknown> | null;
}

export const qaApi = {
  async ask(workspaceId: string, body: { agentKind: 'qa' | 'audit'; question: string }): Promise<QaResult> {
    const r = await api.post<QaResult>(`/api/workspaces/${workspaceId}/qa`, body);
    return r.data;
  },
  async facts(workspaceId: string, ids: (string | number)[]): Promise<FactRow[]> {
    if (ids.length === 0) return [];
    const r = await api.get<FactRow[]>(
      `/api/workspaces/${workspaceId}/facts`,
      { params: { ids: ids.join(',') } },
    );
    return r.data;
  },
};
